// extracted by mini-css-extract-plugin
export default {"container":"zo-z","heading":"Ao-z","items":"Bo-z","action":"Co-z","disabled":"Do-z"};